import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import "css/index.css";

import 'pace'; //https://github.com/HubSpot/pace
import 'pace/themes/red/pace-theme-flash.css';

import 'polyfills';
import 'web-animations-js';

import { store, persistor, maybePurgeStore } from 'store';

import App from './App';

require('lazysizes');
require('lazysizes/plugins/unveilhooks/ls.unveilhooks.min');

// purge store from local storage if persistor key changed 
// current persistor key is returned by the server and attached as body attribute. Its then saved to local storage
// If persistor key from local storage !== current persistor key we purge the store and get new data
maybePurgeStore(persistor);

const Router = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}

ReactDOM.render(<Router />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js